import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Box, Text, Flex } from "@chakra-ui/react";
import { RightArrow } from "../assets/svgs/Icons";
import { ListWithIcon } from "./ListWithIcon";
import { DraftList } from "./DraftList";
import { getFarmers } from "../api";

export const ListCard = (props) => {
  return (
    <Box margin={"1rem"}>
      <Flex flexDirection={"column"}>
        <Box margin={"0.5rem"}>
          <Flex justifyContent={"space-between"}>
            <Text fontSize={"19px"} fontWeight={"800"} color={"brand.blue"}>
              {props.tempId === "1" ? "Farmer On-Boarded" : "Draft"}
            </Text>
            <Text
              fontSize={"13px"}
              fontWeight={"300"}
              color={"#2272D5"}
              paddingTop={"5px"}
              textDecoration={"underline"}
            >
              <Link to={"/supplier"}>View All</Link>
              <RightArrow />
            </Text>
          </Flex>
        </Box>
        <Box
          display={"block"}
          bg={"brand.white"}
          p={"1rem"}
          w={"400px"}
          h={"469px"}
          borderRadius={"15px"}
          overflowY="scroll"
          boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
          css={{
            "&::-webkit-scrollbar": {
              width: "7px",
              height: "225px",
            },
            "&::-webkit-scrollbar-track": {
              width: "7px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#B8DEF8",
              borderRadius: "5px",
            },
          }}
        >
          {props.tempId === "1" ? <ListWithIcon /> : <DraftList />}
        </Box>
      </Flex>
    </Box>
  );
};
